import { SECURITY_EVENTS, EVENT_SEVERITY } from './constants';

const BLOCKED_PROTOCOLS = ['javascript:', 'data:', 'file:', 'vbscript:'];

export function isExternalHref(href, allowedDomains = []) {
  if (!href) return false;
  const raw = String(href).trim();
  const lower = raw.toLowerCase();
  if (BLOCKED_PROTOCOLS.some((p) => lower.startsWith(p))) return true;
  if (lower.startsWith('#') || lower.startsWith('/') || lower.startsWith('?')) return false;
  if (typeof window === 'undefined') return true;
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin === window.location.origin) return false;
    const host = url.hostname.toLowerCase();
    return !allowedDomains.map((d) => String(d).toLowerCase()).includes(host);
  } catch (_) {
    return true;
  }
}

export function subscribeExternalLinkGuard(logSecurityEvent, policy) {
  if (typeof document === 'undefined' || !policy.blockExternalLinks) return () => {};
  const allowed = policy.allowedDomains || [];

  const handler = (event) => {
    const anchor = event.target && event.target.closest ? event.target.closest('a') : null;
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    const target = anchor.getAttribute('target');
    const external = isExternalHref(href, allowed) || target === '_blank';
    if (!external) return;
    event.preventDefault();
    event.stopPropagation();
    logSecurityEvent({
      type: SECURITY_EVENTS.EXTERNAL_LINK_ATTEMPT,
      severity: EVENT_SEVERITY[SECURITY_EVENTS.EXTERNAL_LINK_ATTEMPT],
      message: 'External link navigation was blocked',
      metadata: { href, target }
    });
  };

  document.addEventListener('click', handler, true);
  return () => document.removeEventListener('click', handler, true);
}
